import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { of, TimeoutError } from 'rxjs';
import { ControlBase } from 'src/app/shared/components/generic-form/models/control-base';
import { environment } from 'src/environments/environment';
export interface Control {
    id: number;
    description: string;
    active: boolean;
    userCreated: string;
    dateCreated: Date;
    userModified: string;
    dateModified: Date;
    screenId: number;
    controlType?: string;
    key?: string;
    label?: string;
    required?: boolean;
    disabled?: boolean;
    maxLength?: number;
    order?: number;
    type?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ControlsService {

  private baseUrl = environment.apiBaseUrl + 'api/control';

  constructor(private http: HttpClient) { }

  // TODO: get from a remote source of question metadata
  getControls(screenId: number, options = {}) {
    var controls: ControlBase<string>[] = [];
    console.log(JSON.parse(sessionStorage.getItem('Controls')));
    var jsonControls = JSON.parse(sessionStorage.getItem('Controls'));
    if(screenId in jsonControls){
      for(var control of jsonControls[screenId]) {
        controls.push(new ControlBase({
          controlType: control.controlType,
          key: control.key,
          label: control.label,
          required: control.required,
          disabled: control.disabled,
          maxLength: control.maxLength,
          order: control.order,
          type: control.type,
          options: (control.key in options) ? options[control.key] : []
        }));
      }
    }
    return of(controls.sort((a, b) => a.order - b.order));
  }

  requestControls(screenId: number){
    const url = `${this.baseUrl}/${screenId}`;
    return this.http.get<Control[]>(url)
  }
}
